var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorvinWaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "30 12 212 290",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrench"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(178 170) rotate(40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 0,
    width: 10,
    height: 66,
    rx: 5,
    fill: "#9A938A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A938A",
    d: "M-15 -4 C-15 -20 15 -20 15 -4 L15 6 L6 6 L6 -6 L-6 -6 L-6 6 L-15 6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2 14 L-2 54",
    stroke: "#726C67",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "tail"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1917",
    d: "M78 222 L40 262 L58 262 L50 278 L92 240 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1917",
    d: "M120 128 C78 128 66 176 70 214 C74 248 96 262 122 262 C150 262 170 246 172 214 C175 176 160 128 120 128 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44403C",
    d: "M128 150 C150 160 158 190 154 214 C146 196 138 176 128 150 Z",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 258 L104 282 M136 258 L138 282",
    stroke: "#1C1917",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 282 L92 288 M104 282 L104 290 M104 282 L114 288 M138 282 L128 288 M138 282 L138 290 M138 282 L150 288",
    stroke: "#1C1917",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "wing-left"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1917",
    d: "M74 150 C58 168 56 196 66 214 C72 196 78 178 88 162 Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "belt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B4491C",
    d: "M70 204 C96 214 146 214 172 204 L172 222 C146 232 96 232 70 222 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 206,
    width: 20,
    height: 18,
    rx: 3,
    fill: "none",
    stroke: "#FAF7F3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#963C16",
    d: "M78 220 L104 224 L102 248 C96 252 84 250 80 246 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#963C16",
    d: "M140 224 L164 220 L162 244 C158 249 146 250 142 246 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 198,
    width: 7,
    height: 24,
    rx: 3,
    fill: "#B4491C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 186,
    width: 2.5,
    height: 14,
    fill: "#9A938A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAF7F3",
    d: "M150 222 C152 236 146 246 150 256 C156 248 160 236 158 222 Z",
    opacity: 0.9
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 92,
    r: 46,
    fill: "#1C1917"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1917",
    d: "M156 96 C176 94 196 98 214 108 C200 112 178 114 156 114 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 106 L203 108",
    stroke: "#FAF7F3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 146,
    cy: 88,
    rx: 11,
    ry: 11,
    fill: "#FAF7F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 90,
    r: 5,
    fill: "#1C1917"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.5,
    cy: 88.5,
    r: 1.4,
    fill: "#FAF7F3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1917",
    d: "M133 86 C136 76 156 74 159 84 C152 81 140 81 133 86 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 76 C142 74 152 75 158 77",
    stroke: "#44403C",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    fill: "none"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "cap"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B4491C",
    d: "M84 74 C86 44 112 34 134 38 C152 41 166 54 168 72 C142 64 108 64 84 74 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#963C16",
    d: "M150 66 C166 64 186 66 198 74 C182 78 164 78 150 76 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 40 L126 66",
    stroke: "#963C16",
    strokeWidth: 2
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "wing-right"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1917",
    d: "M152 158 C176 150 196 124 206 86 L212 74 L214 86 L220 72 L220 88 L228 80 C222 120 200 156 160 172 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorvinWaving);
export default __webpack_public_path__ + "static/media/corvin-waving.1391cce6efbff08ee730b2576593d9d5.svg";
export { ForwardRef as ReactComponent };